import React from 'react';
import PropTypes from 'prop-types';
import TableHeading from '../../modules/DataTable/components/TableHeading';

const StatisticsSalesHeader = (props) => {
    function findColumnData(name) {
        return props.children.find(element => element.name === name);
    }

    return (
        <thead>
            <tr>
                <TableHeading
                    {...findColumnData('index_col')}
                    {...props.columns.find(colData => colData.columnName === 'index_col')}
                />
                <TableHeading
                    {...findColumnData('total_count')}
                    {...props.columns.find(colData => colData.columnName === 'total_count')}
                />
                <TableHeading
                    {...findColumnData('offered_count')}
                    {...props.columns.find(colData => colData.columnName === 'offered_count')}
                />
                <TableHeading
                    {...findColumnData('sold_percent')}
                    {...props.columns.find(colData => colData.columnName === 'sold_percent')}
                />
                <TableHeading
                    {...findColumnData('price_total')}
                    {...props.columns.find(colData => colData.columnName === 'price_total')}
                />
                <TableHeading
                    {...findColumnData('price_average')}
                    {...props.columns.find(colData => colData.columnName === 'price_average')}
                />
                <TableHeading
                    {...findColumnData('price_max')}
                    {...props.columns.find(colData => colData.columnName === 'price_max')}
                />
                <TableHeading
                    {...findColumnData('median')}
                    {...props.columns.find(colData => colData.columnName === 'median')}
                />
                <TableHeading
                    {...findColumnData('price_min')}
                    {...props.columns.find(colData => colData.columnName === 'price_min')}
                />
            </tr>
        </thead>
    );
};

StatisticsSalesHeader.propTypes = {
    children: PropTypes.array,
    columns: PropTypes.array,
};

export default StatisticsSalesHeader;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsSalesHeader.js